export class CampaignNotFoundError extends Error {
  constructor() {
    super("shared.errorLoadingTheCampaign");
  }
}
